import { steamRateMap } from '@/pages/opinion/constants/channel';
import { calculateSteamReviewRate } from '@op/utils/text';
import { useMemo } from 'react';

export type RenderKeyType = 'all_reviews' | 'select_all_review' | 'recent_reviews';

export function getSteamReviewRate(
  data: { steam: null | Array<any> },
  renderKey: RenderKeyType = 'all_reviews',
) {
  const { steam }: any = data || {};
  const { name, review, score } = steam?.find(
    (item: { key: string }) => item.key === renderKey,
  ) || {
    name: 'Mixed',
    review: 0,
    score: 0,
  }; 

  const key = name?.replace(/\s/g, ''); // 使用 replace + 正则表达式移除所有空格
  let obj = steamRateMap[key];

  if (!obj) {
    const item = calculateSteamReviewRate(score);
    const newKey = item?.replace(/\s/g, '');
    obj = steamRateMap[newKey];
  }

  return { ...obj, review, score };
}

export default function useDealwithSteam({
  data,
  renderKey,
}: {
  data: { steam: null | Array<any> };
  renderKey?: RenderKeyType;
}) {
  const { icon, name, review, score } = useMemo(() => {
    return getSteamReviewRate(data, renderKey);
  }, [data]);

  return { icon, name, review, score };
}


